<template>
  <div class="home-preview" :class="[deviceType]">
    <div class="preview-header">
      <router-link to="/names" class="preview-title-link">
        <div class="preview-title">Combination Preview</div>
      </router-link>
      <div class="view-more" @click="navigateToNames">
        <span>See More</span>
        <img src="@/assets/default/arrow-right.svg" alt="arrow right" class="arrow-icon" />
      </div>
    </div>
    <div class="preview-content">
      <div class="preview-tabs">
        <div v-for="(tab, index) in tabs" :key="index" class="tab"
          :class="{ 'active': activeTabIndex === index }" @click="setActiveTab(index)"
          @mouseenter="hoveredTabIndex = index" @mouseleave="hoveredTabIndex = null">
          <div class="tab-text">{{ tab.title }}</div>
          <img v-if="activeTabIndex === index" src="@/assets/icons/prevewmore.svg" alt="arrow"
            class="tab-arrow" />
        </div>
      </div>
      <div class="preview-cards">
        <router-link v-for="(card, index) in cards" :key="index"
          :to="`/names/${card.name.toLowerCase()}/${card.id}`" tag="div" class="name-card-link">
          <div class="name-card" :style="{ background: card.background }">
            <div class="card-header">
              <div class="card-info">
                <div class="card-name">{{ card.name }}</div>
                <div class="card-pronunciation">{{ card.pronunciation }}</div>
              </div>
              <div class="card-gender-icon">
                <img :src="card.genderIcon" alt="gender icon" />
              </div>
            </div>
            <div class="card-details">
              <div class="detail-row">
                <span class="detail-label">US Popularity</span>
                <span class="detail-value">{{ card.popularity }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Style</span>
                <span class="detail-value">{{ card.style }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Meaning</span>
                <span class="detail-value text-ellipsis">
                  <span v-for="item in card.meaningList" :key="item">{{ item }} </span>
                </span>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div class="view-more" v-if="deviceType == 'mobile'" @click="navigateToNames">
      <span>See More</span>
      <img src="@/assets/default/arrow-right.svg" alt="arrow right" class="arrow-icon" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HomePreview',
  data () {
    return {
      activeTabIndex: 0,
      hoveredTabIndex: null,
      tabs: [
        {
          title: 'Elegant Girl Names with Grace and Beauty',
          params: {
            gender: ['Girl'],
            meaning: ['Grace', 'Beauty'],
            style: 'Elegant',
          }
        },
        {
          title: 'Modern Girl Names That Shine with Light',
          params: {
            gender: ['Girl'],
            meaning: ['Light'],
            style: 'Modern'
          }
        },
        {
          title: 'Nature-Themed Unisex Names Full of Hope',
          params: {
            gender: ['Unisex'],
            meaning: ['Hope', 'Nature'],
            style: 'Nature'
          }
        }
      ],
      cards: []
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ]),
  },
  methods: {
    setActiveTab (index) {
      this.activeTabIndex = index;
      this.fetchPreviewNames();
    },
    async fetchPreviewNames () {
      try {
        const activeTab = this.tabs[this.activeTabIndex];
        if (!activeTab) return;

        const apiParams = {
          pageSize: '3',
          pageNum: '1',
          ...activeTab.params
        };

        if (this.domainConfig && this.domainConfig.origin) {
          apiParams.origin = this.domainConfig.origin;
        }

        const response = await this.$global.server.postAPI({
          method: 'post',
          params: apiParams,
          url: '/name/page',
        });

        if (response && response.data && response.data.list) {
          const GENDER_COLORS = {
            Boy: 'linear-gradient(180deg, rgba(0, 136, 255, 1) 0%, rgba(0, 136, 255, 0.2) 100%)',
            Girl: 'linear-gradient(180deg, rgba(229, 76, 186, 1) 0%, rgba(229, 76, 186, 0.2) 100%)',
            Unisex: 'linear-gradient(180deg, rgba(200, 173, 23, 1) 0%, rgba(200, 173, 23, 0.2) 100%)'
          };
          this.cards = response.data.list.map(item => {
            return {
              name: item.name || '',
              genderIcon: item.gender === 'Boy'
                ? require('@/assets/icons/male.svg')
                : item.gender === 'Unisex'
                  ? require('@/assets/icons/unsex.svg')
                  : require('@/assets/icons/female.svg'),
              pronunciation: item.pronunciation || '',
              style: item.style || '',
              meaningList: item.meaningList || [],
              popularity: item.popularity || '',
              id: item.id || '',
              background: GENDER_COLORS[item.gender] || GENDER_COLORS.Boy,
            };
          });
          console.log('Preview names fetched successfully:', response.data);
        } else {
          this.cards = [];
        }
      } catch (error) {
        console.error('Error fetching preview names:', error);
        this.cards = [];
      }
    },
    navigateToNames () {
      const activeTab = this.tabs[this.activeTabIndex];
      if (activeTab && activeTab.params) {
        this.$router.push({ path: '/names', query: activeTab.params });
      } else {
        this.$router.push('/names');
      }
    },
  },
  mounted () {
    this.fetchPreviewNames();
  },
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-preview {
	padding: rem(40) rem(180);
	display: flex;
	flex-direction: column;
	gap: rem(24);
	background: #000;

	.preview-header {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: rem(22);

		.preview-title-link {
			text-decoration: none;
			cursor: pointer;
		}

		.preview-title {
			color: #ffffff;
			font-size: rem(24);
			line-height: rem(28);
			font-weight: 900;
		}
	}
	.view-more {
		background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
		border-radius: rem(8);
		padding: rem(8) rem(16);
		display: flex;
		gap: rem(8);
		align-items: center;
		cursor: pointer;

		span {
			color: #ffffff;
			font-size: rem(12);
			line-height: rem(12);
			font-weight: 700;
		}

		.arrow-icon {
			width: rem(6);
			height: rem(10);
			filter: brightness(0) invert(1);
		}
	}

	.preview-content {
		display: flex;
		gap: rem(24);

		.preview-tabs {
			display: flex;
			flex-direction: column;
			gap: rem(8);
			width: rem(252);

			.tab {
				border-radius: rem(16);
				padding: rem(12) rem(16);
				cursor: pointer;
				transition: all 0.3s ease;
				border: 1px solid transparent;
				background: rgba(255, 255, 255, 0.1);
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: rem(58);
				box-sizing: border-box;

				.tab-text {
					color: rgba(255, 255, 255, 0.7);
					font-size: rem(13);
					line-height: rem(18);
				}

				.tab-arrow {
					width: rem(14);
					height: rem(14);
				}

				&:hover {
					border-color: rgba(255, 255, 255, 0.2);
				}

				&.active {
					border-color: #ffffff;
					background: transparent;

					.tab-text {
						color: #ffffff;
					}
				}
			}
		}

		.preview-cards {
			display: flex;
			gap: rem(24);
			flex: 1;

			.name-card-link {
				text-decoration: none;
				width: calc(33.333% - rem(16));

				.name-card {
					border-radius: rem(16);
					padding: rem(16);
					display: flex;
					flex-direction: column;
					gap: rem(16);
					width: 100%;
					box-sizing: border-box;

					.card-header {
						display: flex;
						justify-content: space-between;
						align-self: stretch;

						.card-info {
							.card-name {
								color: #ffffff;
								font-size: rem(20);
								line-height: rem(20);
								font-weight: 900;
							}

							.card-pronunciation {
								color: #ffffff;
								font-size: rem(12);
								line-height: rem(12);
								font-weight: 300;
								font-style: italic;
								margin-top: rem(8);
							}
						}

						.card-gender-icon {
							width: rem(24);
							height: rem(24);
							background: #fff;
							border-radius: rem(8);
							display: flex;
							align-items: center;
							justify-content: center;

							img {
								width: rem(16);
								height: rem(16);
							}
						}
					}

					.card-details {
						display: flex;
						flex-direction: column;
						gap: rem(8);
						align-self: stretch;

						.detail-row {
							background: rgba(255, 255, 255, 0.1);
							border-radius: rem(8);
							padding: rem(8) rem(12);
							display: flex;
							justify-content: space-between;
							align-items: center;
							height: rem(32);
							box-sizing: border-box;

							.detail-label,
							.detail-value {
								color: #ffffff;
								font-size: rem(12);
								line-height: rem(12);
							}

							.detail-value {
								font-weight: 700;
								&.text-ellipsis {
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
								}
							}
						}
					}
				}
			}
		}
	}
}

.detect_deviece_mobile {
	.home-preview {
		padding: rem(40) 0 rem(40) rem(16);

		.preview-header {
			.view-more {
				display: none;
			}
		}

		.view-more {
			width: fit-content;
		}

		.preview-content {
			flex-direction: column;

			.preview-tabs {
				flex-direction: row;
				overflow-x: auto;
				width: 100%;
				padding: rem(5) 0;
				// Hide scrollbar
				-ms-overflow-style: none;
				/* IE and Edge */
				scrollbar-width: none;
				/* Firefox */

				&::-webkit-scrollbar {
					display: none;
				}

				.tab {
					flex-shrink: 0;
					width: rem(280);
					gap: rem(16);
					.tab-arrow {
						transform: rotate(90deg);
					}
				}
			}

			.preview-cards {
				overflow-x: auto;
				padding-bottom: rem(8);

				&::-webkit-scrollbar {
					display: none;
				}

				-ms-overflow-style: none;
				scrollbar-width: none;

				.name-card-link {
					width: rem(252);
					flex-shrink: 0;
				}
			}
		}
	}
}
</style>